export const SET_ORDER = "SET_ORDER"

export function setOrder(order){
	return {
		type: SET_ORDER,
		order: order
	}
}
